import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { WzValidators } from '@wz-validators';

@Directive({
  // tslint:disable-next-line:directive-selector : overriding built-in selectors
  selector:
    '[atLeastOneLetterRequired][formControlName],[atLeastOneLetterRequired][formControl],[atLeastOneLetterRequired][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AtLeastOneLetterRequiredDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class AtLeastOneLetterRequiredDirective implements Validator {
  constructor() {}

  validate(thisControl: AbstractControl): { [key: string]: any } | any {
    return WzValidators.atLeastOneLetterRequired(thisControl);
  }
}
